import { Icon, IconProps, useThemeValues } from '@frontend/design-system';

type Props = IconProps & {
  active: boolean;
};

export const FacebookRecommendationIcon = ({ size = 16, active, ...props }: Props) => {
  const theme = useThemeValues();
  const colors = {
    positive: '#E74F47',
    negative: theme.name === 'original' ? theme.colors.gray400 : theme.colors.neutral40,
  };
  return (
    <Icon viewBox={'0, 0, 16, 16'} size={size} {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 1.152C0 .516.516 0 1.152 0h13.696C15.484 0 16 .516 16 1.152v9.255c0 .636-.516 1.152-1.152 1.152H6.315l-.013.02-2.804 4.197c-.295.44-.982.18-.911-.345l.523-3.872H1.152C.516 11.559 0 11.043 0 10.407V1.152zm7.594.816L6.579 4.035l-2.271.333c-.332.05-.464.461-.223.697l1.641 1.607-.387 2.27c-.057.333.289.587.585.43L7.956 8.3l2.03 1.074c.297.156.643-.098.586-.431l-.387-2.27 1.641-1.607c.241-.236.11-.648-.223-.697l-2.27-.333-1.016-2.067c-.148-.302-.575-.302-.723 0z'
        fill={active ? colors.positive : colors.negative}
      />
    </Icon>
  );
};
